import React from 'react';
import { SizeArray } from '../SizeArray';
import { useProductSizes } from '../../LeftWorkArea/LeftWorkSize/useProductSizes';
import './colorSubfooter.scss'
import { ArrayHeader } from '../ArrayHeader';
import { DEFAULT_TAB, TABS, tabType } from '../constants';
import { ColorArray } from '../ColorArray';
import { useProductColors } from '../../LeftWorkArea/LeftWorkColor/useProductColors';

interface IProductSubFooter {
    tabSelection: (tab: tabType) => void
}

export const ColorSubFooter = (props: IProductSubFooter) => {

    const{colors, handleSelectColor, selectedColor} = useProductColors();

    return <div className='color-subfooter' style={{zIndex: 100}}>
        <ArrayHeader goBack={() => {
            props.tabSelection(DEFAULT_TAB);
        }} title={'CHOOSE PRODUCT COLOR'} />
        <ColorArray onColorSelected={handleSelectColor} colors={colors} defaultColor={selectedColor} />
    </div>
}